import * as React from "react";
import type { SVGProps } from "react";
const SvgThreePeople = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.312 9.116A3.4 3.4 0 0 1 4.57 7.17l-.09-1.66C4.48 3.55 6.03 2 7.93 2h.15a3.46 3.46 0 0 1 3.424 3.026Q11.714 5 11.93 5h.15q.22 0 .433.027c.235-1.72 1.68-3.017 3.417-3.017h.15c1.9 0 3.45 1.55 3.45 3.45l-.1 1.72a3.4 3.4 0 0 1-.728 1.929C20.597 9.55 22 11.169 22 13.1v1.89c0 .55-.45 1-1 1V16h-1.58c.371.712.58 1.513.58 2.36V21c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-2.64c0-.846.21-1.647.582-2.36H3c-.55 0-1-.45-1-1v-1.89c0-1.934 1.415-3.556 3.312-3.994m3.425 1.94a2.7 2.7 0 0 0-.517-.046H6.34c-1.29 0-2.34.95-2.34 2.11v.89h2.368A5.88 5.88 0 0 1 9.68 13h.69a3.44 3.44 0 0 1-1.633-1.943M9.54 5.4l-.032.605a3.52 3.52 0 0 0-1.024 2.334q-.227.081-.474.081c-.76 0-1.39-.59-1.43-1.35l-.09-1.61c0-.8.65-1.45 1.45-1.45h.15c.8 0 1.45.65 1.45 1.39M16 20v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-4v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H6v-1.64C6 16.51 7.65 15 9.68 15h4.64c2.03 0 3.68 1.51 3.68 3.36V20zm1.621-6H20v-.89c0-1.16-1.05-2.11-2.34-2.11h-1.88q-.265 0-.515.05A3.44 3.44 0 0 1 13.629 13h.691c1.23 0 2.37.37 3.301 1M16 8.41q-.246 0-.472-.08A3.44 3.44 0 0 0 14.5 5.995l-.031-.536c0-.8.65-1.45 1.45-1.45h.15c.8 0 1.45.65 1.45 1.39l-.09 1.66c-.04.76-.67 1.35-1.43 1.35m-5.52.04c0-.8.65-1.45 1.45-1.45l-.01.01h.15c.8 0 1.45.65 1.45 1.39l-.09 1.66c-.04.76-.67 1.35-1.43 1.35s-1.39-.59-1.43-1.35z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgThreePeople;
